import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './main.scss';
Vue.config.productionTip = false

import {newReq, newReqDownloadFile, newReqUpload} from './core/request';
Vue.prototype.$newReq = newReq;
Vue.prototype.$newReqDownloadFile = newReqDownloadFile;
Vue.prototype.$newReqUpload = newReqUpload;

import snack from './core/snack'
Vue.prototype.$snack = snack;

import store from './core/store'

new Vue({
  vuetify,
  render: h => h(App),
  store: store
}).$mount('#app')
